"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
const FormUtil_1 = require("../../Components/Form/FormUtil");
const Druid_1 = require("../../Druid");
const Collection_1 = require("../../Collection/Collection");
const TypeGuard_1 = require("../../Types/TypeGuard");
const Selectors_1 = require("../../Utility/Selectors");
class OnEventHandler {
    constructor() {
        this.disabledFunctions = new Collection_1.default([], (left, right) => left.context === right.context && left.function === right.function && left.element === right.element);
    }
    handleEvent(component, fn, evt, options) {
        // filter the event if necessary
        if ((options === null || options === void 0 ? void 0 : options.filter) && options.filter(evt) === true) {
            return;
        }
        // if the delegate target has disabled attribute, ignore event. Unless `always` is set
        if ((options === undefined || options.always !== true) && evt.delegateTarget.hasAttribute('disabled')) {
            return;
        }
        // event is already handled by another decorator. Ignore. Note: using stopPropagation is undesired in this scenario
        // istanbul ignore next
        if (this.decoratorConsumedEvent === evt.event) {
            return;
        }
        this.decoratorConsumedEvent = evt.event;
        // function is disabled while processing, no further calls to this function till the promises rejects or resolves
        if (this.disabledFunctions.contains({ function: fn, context: component, element: evt.delegateTarget })) {
            return;
        }
        if ((options === null || options === void 0 ? void 0 : options.disable) === true) {
            evt.delegateTarget.disabled = true;
            evt.delegateTarget.setAttribute('disabled', 'disabled');
        }
        // find context parent element by role
        const args = [];
        args.push(evt);
        let context = null;
        if (options === null || options === void 0 ? void 0 : options.context) {
            context = evt.target.closest(Selectors_1.default.createDataRoleSelector(options.context));
            args.unshift(context);
            if (options.disableContext === true && context !== null) {
                FormUtil_1.default.disableForm(context, true);
            }
        }
        const result = fn.apply(component, args);
        this.handleBrowserEvent(result, evt, options);
        this.handleDisable(result, component, fn, evt.delegateTarget, options);
        this.handleLoader(result, component, options);
        this.handleContextDisable(result, context, options);
        this.handleLoadIndicator(result, evt.delegateTarget);
    }
    /**
     * Handle the specific browser event. Prevent default browser behaviour when necessary
     */
    handleBrowserEvent(result, evt, options) {
        // result can be false or undefined. Only skip if explicitly set to false
        if (result !== false) {
            evt.event.preventDefault();
        }
        // stop event bubbling
        if (options && options.stopEvent === true) {
            evt.event.stopImmediatePropagation();
            evt.event.preventDefault();
        }
    }
    /**
     * If disable was set in options, enable element when promise resolves
     */
    handleDisable(result, component, fn, target, options) {
        if ((options === null || options === void 0 ? void 0 : options.disable) !== true) {
            return;
        }
        // if result is promise, enable element when promise is completed
        // istanbul ignore next
        if (TypeGuard_1.default.isPromise(result)) {
            // disable function while promise is running
            this.disabledFunctions.add({ function: fn, context: component, element: target });
            result.finally(() => {
                target.disabled = false;
                target.removeAttribute('disabled');
                // remove disabled function from the list
                this.disabledFunctions.remove({ function: fn, context: component, element: target });
            });
        }
        else {
            target.disabled = false;
            target.removeAttribute('disabled');
        }
    }
    /**
     * If loader:true was set in options, start and stop loader on the view while the promise is running
     */
    handleLoader(result, component, options) {
        if (TypeGuard_1.default.isPromise(result) === false || (options === null || options === void 0 ? void 0 : options.loader) !== true) {
            return;
        }
        component.loader.start();
        result.finally(() => component.loader.stop());
    }
    handleContextDisable(result, context, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableContext) !== true || context === null) {
            return;
        }
        if (TypeGuard_1.default.isPromise(result)) {
            result.finally(() => FormUtil_1.default.disableForm(context, false));
        }
        else {
            FormUtil_1.default.disableForm(context, false);
        }
    }
    /**
     * Add load indicator when the result is a promise, and the target element has `dr-icon` attribute
     */
    handleLoadIndicator(result, target) {
        // if result is promise, enable element when promise is completed
        if (TypeGuard_1.default.isPromise(result) === false) {
            return;
        }
        const iconClass = Druid_1.default.configuration().icon.className;
        const loadingClass = Druid_1.default.configuration().icon.loading;
        if (target.classList.contains(iconClass) === false) {
            return;
        }
        target.classList.add(loadingClass);
        result.finally(() => target.classList.remove(loadingClass));
    }
}
exports.default = OnEventHandler;
//# sourceMappingURL=OnEventHandler.js.map